/**
 * Version will be automatically change in CI/CD process.
 * Do not remove or changed the tag.
 * Do not replace the tag with value.
 *
 * The automatically change of the tag will force cache busting of main @angular entry point.
 *
 * Main File Version: 6365
 */

import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';

import {labels} from './assets/tenants/labels';

import {environment} from './environments/environment';

if (environment.production) {
    enableProdMode();
}

document.title = labels.tenant + ' CRM';

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
